/**
 * @generated SignedSource<<3bf7d3ffdd0796e82141463a5707e854>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PerpsPoolBalanceSubscription$variables = {
  id: string;
};
export type PerpsPoolBalanceSubscription$data = {
  readonly node: {
    readonly availableYieldLp?: {
      readonly amount: bigint;
      readonly valueUsd: bigint;
    };
    readonly availableYieldXlp?: {
      readonly amount: bigint;
      readonly valueUsd: bigint;
    };
    readonly id?: string;
    readonly lpShares?: bigint;
    readonly lpSize?: {
      readonly amount: bigint;
      readonly valueUsd: bigint;
    };
    readonly xlpShares?: bigint;
    readonly xlpSize?: {
      readonly amount: bigint;
      readonly valueUsd: bigint;
    };
  } | null | undefined;
};
export type PerpsPoolBalanceSubscription = {
  response: PerpsPoolBalanceSubscription$data;
  variables: PerpsPoolBalanceSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "valueUsd",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Balance",
  "kind": "LinkedField",
  "name": "lpSize",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lpShares",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Balance",
  "kind": "LinkedField",
  "name": "xlpSize",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "xlpShares",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Balance",
  "kind": "LinkedField",
  "name": "availableYieldLp",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Balance",
  "kind": "LinkedField",
  "name": "availableYieldXlp",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PerpsPoolBalanceSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "PerpsAccount",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PerpsPoolBalanceSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "type": "PerpsAccount",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6370783ceebbd02c700dce70df4f9107",
    "id": null,
    "metadata": {},
    "name": "PerpsPoolBalanceSubscription",
    "operationKind": "subscription",
    "text": "subscription PerpsPoolBalanceSubscription(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on PerpsAccount {\n      id\n      lpSize {\n        amount\n        valueUsd\n      }\n      lpShares\n      xlpSize {\n        amount\n        valueUsd\n      }\n      xlpShares\n      availableYieldLp {\n        amount\n        valueUsd\n      }\n      availableYieldXlp {\n        amount\n        valueUsd\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1096a44365383af0d2b3d8b065b14386";

export default node;
